import { render } from "./TheMobileAR.vue?vue&type=template&id=7064d8cd&scoped=true"
import script from "./TheMobileAR.vue?vue&type=script&lang=js"
export * from "./TheMobileAR.vue?vue&type=script&lang=js"

import "./TheMobileAR.vue?vue&type=style&index=0&id=7064d8cd&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7064d8cd"]])

export default __exports__